/* 
------------------------------------------------------------------------------------
	Function: ResizeImageJS
	Note: Resize to MAX_SIZE keeping aspect ratio.
------------------------------------------------------------------------------------	
*/
function ResizeImageJS(SelectedCounts, imgfile, imgfiledata, MAX_SIZE, TotalImagesLoaded)
{
	// Note: SelectedCounts contain the following counts
	// SelectedCounts[0] = Selected Count
	// SelectedCounts[1] = Selected Loaded Success Count
	// SelectedCounts[2] = Selected Loaded Error Count
	// SelectedCounts[3] = IsLoading
	// SelectedCounts[4] = TotalImagesToUpload
	// SelectedCounts[5] = TotalImagesUploaded
	// SelectedCounts[6] = IsUploading	

	// Create work image for resizing
	let img = document.createElement("img");

	img.onerror = function () 
	{
		console.log("ERROR: Invalid Image! -> ", imgfile.name);

		SelectedCounts[2]++;

		//
		// Are We Done Yet?
		//
		if (SelectedCounts[1] + SelectedCounts[2] == SelectedCounts[0])
		{
			SelectedCounts[3] = 0;								//IsLoading
			console.log("Image load complete with errors..", new Date().toLocaleTimeString("en-US"));
		}
	}

	img.onload = function () 
	{
		let width = img.width;
		let height = img.height;

		if (width >= height)
		{
			// Landscape
			height = Math.round(img.height * (MAX_SIZE / img.width));
			width = MAX_SIZE;
		}
		else
		{
			// Portrait
			width = Math.round(img.width * (MAX_SIZE / img.height));
			height = MAX_SIZE;
		}

		let canvas = document.createElement("canvas");

		canvas.width = width;
		canvas.height = height;

		let ctx = canvas.getContext("2d");

		ctx.drawImage(img, 0, 0, width, height);

		let obj =
		{
			PhotoName: imgfile.name,
			PhotoOrientation: 1,
			PhotoDateTime: new Date(imgfile.lastModified),
			PhotoUrl: canvas.toDataURL("image/jpeg"),
			PhotoIsUploaded: false
		};

		TotalImagesLoaded.push(obj);
		SelectedCounts[1]++;

		//
		// Are We Done Yet?
		//
		if (SelectedCounts[1] + SelectedCounts[2] == SelectedCounts[0])
		{
			SelectedCounts[3] = 0;								//IsLoading
			console.log("Image load complete..", new Date().toLocaleTimeString("en-US"));
		}

	};

	// Load The Image Data
	img.src = imgfiledata;
}


/* 
------------------------------------------------------------------------------------
	Function: ResizeRotateImageJS
	Note: Resize to MAX_SIZE keeping aspect ratio and rotate if necessary.
------------------------------------------------------------------------------------	
*/
function ResizeRotateImageJS(SelectedCounts, imgfile, imgfiledata, orientation, MAX_SIZE, TotalImagesLoaded)
{
	// Note: SelectedCounts contain the following counts
	// SelectedCounts[0] = Selected Count
	// SelectedCounts[1] = Selected Loaded Success Count
	// SelectedCounts[2] = Selected Loaded Error Count
	// SelectedCounts[3] = IsLoading
	// SelectedCounts[4] = TotalImagesToUpload
	// SelectedCounts[5] = TotalImagesUploaded
	// SelectedCounts[6] = IsUploading	

	// Create work image for resizing
	let img = document.createElement("img");

	img.onerror = function () 
	{
		console.log("ERROR: Invalid Image! -> ", imgfile.name);

		SelectedCounts[2]++;

		//
		// Are We Done Yet?
		//
		console.log(SelectedCounts[1] + SelectedCounts[2] + " of " + SelectedCounts[0], " - ", imgfile.name);

		if (SelectedCounts[1] + SelectedCounts[2] == SelectedCounts[0])
		{
			SelectedCounts[3] = 0;								//IsLoading
			console.log("Image load complete with errors..", new Date().toLocaleTimeString("en-US"));
		}
	}

	img.onload = function () 
	{
		let RotateDeg = 0;

		switch (orientation) 
		{
			case 1: case 2:
				RotateDeg = 0;		// Image is rotated 0°, No rotation needed
				break;
			case 3: case 4:
				RotateDeg = 180;	// Image is rotated 180° or -180°, need to rotate back
				break;
			case 5: case 6:
				RotateDeg = 90;		// Image is rotated -90° or 270°, need to rotate back
				break;
			case 7: case 8:
				RotateDeg = -90;	// Image is rotated 90° or -270°, need to rotate back
				break;
			default:
				RotateDeg = 0;		// No rotation needed
		}

		let width = img.width;
		let height = img.height;

		if (width >= height)
		{
			// Landscape
			height = Math.round(img.height * (MAX_SIZE / img.width));
			width = MAX_SIZE;
		}
		else
		{
			// Portrait
			width = Math.round(img.width * (MAX_SIZE / img.height));
			height = MAX_SIZE;
		}

		let canvas = document.createElement("canvas");

		if (RotateDeg == 0 | RotateDeg == 180)
		{
			canvas.width = width;
			canvas.height = height;
		}
		else
		{
			canvas.width = height;
			canvas.height = width;
		}

		let ctx = canvas.getContext("2d");

		if (RotateDeg == 0)
		{
			ctx.drawImage(img, 0, 0, width, height);
		}
		else
		{
			drawImageRotated(ctx, img, 0, 0, width, height, RotateDeg);
		}

		let obj =
		{
			PhotoName: imgfile.name,
			PhotoOrientation: orientation,
			PhotoDateTime: new Date(imgfile.lastModified),
			PhotoUrl: canvas.toDataURL("image/jpeg"),
			PhotoIsUploaded: false
		};

		TotalImagesLoaded.push(obj);
		SelectedCounts[1]++;

		//
		// Are We Done Yet?
		//
		console.log(SelectedCounts[1] + SelectedCounts[2] + " of " + SelectedCounts[0], " - ", imgfile.name);

		if (SelectedCounts[1] + SelectedCounts[2] == SelectedCounts[0])
		{
			SelectedCounts[3] = 0;								//IsLoading
			console.log("Image load complete..", new Date().toLocaleTimeString("en-US"));
		}

	};

	// Load The Image Data
	img.src = imgfiledata;
}

/* 
------------------------------------------------------------------------------------
	Function: drawImageRotated
	Note: 
------------------------------------------------------------------------------------	
*/
function drawImageRotated(ctx, image, x, y, w, h, degrees)
{
	ctx.save();
	
	if (degrees == 0 || degrees == 180)
	{
		ctx.translate(x + w / 2, y + h / 2);
	}
	else
	{
		ctx.translate(x + h / 2, y + w / 2);
	}
	ctx.rotate(degrees * Math.PI / 180.0);
	ctx.translate(-x - w / 2, -y - h / 2);
	ctx.drawImage(image, x, y, w, h);
	ctx.restore();
}